import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const DOM_SNAPSHOT_LIMIT = 50000;
const TRUNCATION_NOTE = '\n<!-- truncated -->';
/**
 * Client-side handler for the `get_current_page_context` agent tool
 */
export class PageContextClientTool {
    constructor(_store) {
        this._store = _store;
    }
    async execute(_input) {
        const { sliceKey, sliceState } = await this._readStoreSlice();
        return {
            page_title: document.title,
            url: window.location.href,
            app_state_slice_key: sliceKey,
            app_state: sliceState,
            dom_snapshot: this._cleanDomSnapshot(document.body?.innerHTML ?? ''),
        };
    }
    async getCurrentSliceKey() {
        const { sliceKey } = await this._readStoreSlice();
        return sliceKey;
    }
    async _readStoreSlice() {
        if (!this._store) {
            return { sliceKey: null, sliceState: null };
        }
        const snapshot = await firstValueFrom(this._store.select((state) => state).pipe(take(1)));
        const reducers = snapshot?.reducers ?? {};
        const sliceKey = reducers.appStateSliceKey ?? null;
        const sliceState = sliceKey && reducers[sliceKey] ? reducers[sliceKey] : null;
        return { sliceKey, sliceState };
    }
    _cleanDomSnapshot(html) {
        const container = document.createElement('div');
        container.innerHTML = html;
        // Strip non-content tags (scripts, styles, vectors, and app chrome)
        container
            .querySelectorAll('script, style, svg, ycn-top-bar-nav, ycn-agent-side-panel')
            .forEach((el) => el.remove());
        let cleaned = container.innerHTML
            // Strip noise attributes: framework internals, presentational, and tracking
            .replace(/\s(class|style|data-[\w-]+|_ngcontent-[\w-]+|_nghost-[\w-]+|ng-reflect-[\w-]+|aria-labelledby|aria-describedby)="[^"]*"/g, '')
            // Empty attributes after stripping
            .replace(/\s(class|style)=""/g, '')
            // Collapse whitespace last
            .replace(/\s+/g, ' ')
            .trim();
        if (cleaned.length > DOM_SNAPSHOT_LIMIT) {
            cleaned = cleaned.slice(0, DOM_SNAPSHOT_LIMIT - TRUNCATION_NOTE.length) + TRUNCATION_NOTE;
        }
        return cleaned;
    }
}
PageContextClientTool.ɵfac = function PageContextClientTool_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PageContextClientTool)(i0.ɵɵinject(i1.Store, 8)); };
PageContextClientTool.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PageContextClientTool, factory: PageContextClientTool.ɵfac, providedIn: 'root' });
